import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_child_serialnumbers_grid_ComponentContextService } from './FootprintManager.child_serialnumbers_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface IFootprintManager_child_serialnumbers_gridComponentEntity {
  Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, GrossVolume?: number, GrossWeight?: number, Height?: number, Length?: number, LookupCode?: string, NetVolume?: number, NetWeight?: number, Notes?: string, Width?: number, Lot?: { Id?: number, LookupCode?: string, Material?: { Id?: number, LookupCode?: string, ProjectId?: number, Project?: { LookupCode?: string } }, VendorLot?: { LookupCode?: string } }, LicensePlate?: { Id?: number, LookupCode?: string, Location?: { Id?: number, Name?: string, Warehouse?: { Name?: string } }, Type?: { Name?: string } }, Status?: { Name?: string }, DimensionsUom?: { Short_name?: string }, WeightUom?: { Short_name?: string }, VolumeUom?: { Short_name?: string }, Packaging?: { ShortName?: string }, OutboundShipment?: { LookupCode?: string, Status?: { Name?: string } }}

interface IFootprintManager_child_serialnumbers_gridComponentInParams {
  chainHead: number, archived: boolean, fullTextSearch?: string}


class FootprintManager_child_serialnumbers_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_child_serialnumbers_gridComponent;
  entity: IFootprintManager_child_serialnumbers_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    Id: null,
    lookupcode: null,
    packaging: null,
    parent_path: null,
    status: null,
    material: null,
    lot: null,
    vendor_lot: null,
    project: null,
    net_weight: null,
    gross_weight: null,
    weight_uom: null,
    length: null,
    width: null,
    height: null,
    dimension_uom: null,
    net_volume: null,
    gross_volume: null,
    volume_uom: null,
    created_date: null,
    created_user: null,
    licenseplate_type: null,
    licenseplate: null,
    location: null,
    warehouse: null,
    outbound_shipment: null,
    outbound_shipment_status: null,
    notes: null,
  }



  constructor(
    grid: FootprintManager_child_serialnumbers_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_child_serialnumbers_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.lookupcode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.lookupcode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.packaging = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.packaging,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.parent_path = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.parent_path,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.status = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.status,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.material = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.material,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.lot = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.lot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.vendor_lot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.vendor_lot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.project = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.project,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.net_weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.net_weight,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.gross_weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.gross_weight,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.weight_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.weight_uom,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.length = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.length,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.width = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.width,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.height = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.height,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.dimension_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.dimension_uom,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.net_volume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.net_volume,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.gross_volume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.gross_volume,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.volume_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.volume_uom,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.created_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_date,
      new TextModel(null, null,  'datetime', 'l, LT', null)
,
null
      );
    
    this.cells.created_user = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_user,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.licenseplate_type = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.licenseplate_type,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.licenseplate = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.licenseplate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.location = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.warehouse = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.warehouse,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.outbound_shipment = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.outbound_shipment,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.outbound_shipment_status = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.outbound_shipment_status,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.notes = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.notes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_child_serialnumbers_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_child_serialnumbers_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      chainHead:  $grid.inParams.chainHead ,
      archived:  false ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    const data = await this.$datasources.SerialNumbers.ds_child_serialnumbers_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_child_serialnumbers_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Id.displayControl as TextModel).text = $row.entity.Id?.toString();
    (this.cells.lookupcode.displayControl as TextModel).text = $row.entity.LookupCode;
    (this.cells.packaging.displayControl as TextModel).text = $row.entity.Packaging?.ShortName;
    (this.cells.status.displayControl as TextModel).text = $row.entity.Status?.Name;
    (this.cells.material.displayControl as TextModel).text = $row.entity.Lot?.Material?.LookupCode;
    (this.cells.lot.displayControl as TextModel).text = $row.entity.Lot?.LookupCode;
    (this.cells.vendor_lot.displayControl as TextModel).text = $row.entity.Lot?.VendorLot?.LookupCode;
    (this.cells.project.displayControl as TextModel).text = $row.entity.Lot?.Material?.Project?.LookupCode;
    (this.cells.net_weight.displayControl as TextModel).text = $row.entity.NetWeight?.toString();
    (this.cells.gross_weight.displayControl as TextModel).text = $row.entity.GrossWeight?.toString();
    (this.cells.weight_uom.displayControl as TextModel).text = $row.entity.WeightUom?.Short_name;
    (this.cells.length.displayControl as TextModel).text = $row.entity.Length?.toString();
    (this.cells.width.displayControl as TextModel).text = $row.entity.Width?.toString();
    (this.cells.height.displayControl as TextModel).text = $row.entity.Height?.toString();
    (this.cells.dimension_uom.displayControl as TextModel).text = $row.entity.DimensionsUom?.Short_name;
    (this.cells.net_volume.displayControl as TextModel).text = $row.entity.NetVolume?.toString();
    (this.cells.gross_volume.displayControl as TextModel).text = $row.entity.GrossVolume?.toString();
    (this.cells.volume_uom.displayControl as TextModel).text = $row.entity.VolumeUom?.Short_name;
    (this.cells.created_date.displayControl as TextModel).text = $row.entity.CreatedSysDateTime?.toString();
    (this.cells.created_user.displayControl as TextModel).text = $row.entity.CreatedSysUser;
    (this.cells.licenseplate_type.displayControl as TextModel).text = $row.entity.LicensePlate?.Type?.Name;
    (this.cells.licenseplate.displayControl as TextModel).text = $row.entity.LicensePlate?.LookupCode;
    (this.cells.location.displayControl as TextModel).text = $row.entity.LicensePlate?.Location?.Name;
    (this.cells.warehouse.displayControl as TextModel).text = $row.entity.LicensePlate?.Location?.Warehouse?.Name;
    (this.cells.outbound_shipment.displayControl as TextModel).text = $row.entity.OutboundShipment?.LookupCode;
    (this.cells.outbound_shipment_status.displayControl as TextModel).text = $row.entity.OutboundShipment?.Status?.Name;
    (this.cells.notes.displayControl as TextModel).text = $row.entity.Notes;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'lookupcode' : {
        this.on_lookupcode_clicked();
        break;
      }
      case 'material' : {
        this.on_material_clicked();
        break;
      }
      case 'lot' : {
        this.on_lot_clicked();
        break;
      }
      case 'project' : {
        this.on_project_clicked();
        break;
      }
      case 'licenseplate' : {
        this.on_licenseplate_clicked();
        break;
      }
      case 'location' : {
        this.on_location_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_material_clicked(event = null) {
    return this.on_material_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_material_clickedInternal(
    $row: FootprintManager_child_serialnumbers_gridComponentRowModel,
  $grid: FootprintManager_child_serialnumbers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_child_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_material_hub({materialId: $row.entity.Lot.Material.Id});
  }
  on_licenseplate_clicked(event = null) {
    return this.on_licenseplate_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_licenseplate_clickedInternal(
    $row: FootprintManager_child_serialnumbers_gridComponentRowModel,
  $grid: FootprintManager_child_serialnumbers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_child_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  
  $shell.FootprintManager.opensingle_licenseplate_hub({licenseplateId: $row.entity.LicensePlate.Id});
  }
  on_location_clicked(event = null) {
    return this.on_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_location_clickedInternal(
    $row: FootprintManager_child_serialnumbers_gridComponentRowModel,
  $grid: FootprintManager_child_serialnumbers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_child_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_location_hub({locationId: $row.entity.LicensePlate.Location.Id});
  }
  on_lot_clicked(event = null) {
    return this.on_lot_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lot_clickedInternal(
    $row: FootprintManager_child_serialnumbers_gridComponentRowModel,
  $grid: FootprintManager_child_serialnumbers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_child_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_lot_hub({lotId: $row.entity.Lot.Id});
  }
  on_project_clicked(event = null) {
    return this.on_project_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_project_clickedInternal(
    $row: FootprintManager_child_serialnumbers_gridComponentRowModel,
  $grid: FootprintManager_child_serialnumbers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_child_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_project_hub({projectId: $row.entity.Lot.Material.ProjectId});
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_child_serialnumbers_gridComponentRowModel,
  $grid: FootprintManager_child_serialnumbers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_child_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  var serialNumberId = $row.entity.Id;
  
  //let serialPath = (await $flows.SerialNumbers.get_serialnumber_parent_path({serialnumberId: serialNumberId}));
  //if ($utils.isDefined(serialPath)){
  //
  //    $row.cells.parent_path.displayControl.text = serialPath.serialPath;
  //}
  }
  on_lookupcode_clicked(event = null) {
    return this.on_lookupcode_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lookupcode_clickedInternal(
    $row: FootprintManager_child_serialnumbers_gridComponentRowModel,
  $grid: FootprintManager_child_serialnumbers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_child_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_serialnumber_hub({serialnumberId: $row.entity.Id});
  
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootprintManager-child_serialnumbers_grid',
  templateUrl: './FootprintManager.child_serialnumbers_grid.component.html'
})
export class FootprintManager_child_serialnumbers_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_child_serialnumbers_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_child_serialnumbers_gridComponentInParams = { chainHead: null, archived: null, fullTextSearch: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Id: new GridHeaderModel(new HeaderStyles(null, null), 'Id', 'ID', false, false, null, false),       lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'lookupcode', 'Serial number', false, false, null, false),       packaging: new GridHeaderModel(new HeaderStyles(null, null), 'packaging', 'Packaging', false, false, null, false),       parent_path: new GridHeaderModel(new HeaderStyles(null, null), 'parent_path', 'Parent path', false, false, null, false),       status: new GridHeaderModel(new HeaderStyles(null, null), 'status', 'Status', false, false, null, false),       material: new GridHeaderModel(new HeaderStyles(null, null), 'material', 'Material', false, false, null, false),       lot: new GridHeaderModel(new HeaderStyles(null, null), 'lot', 'Lot', false, false, null, false),       vendor_lot: new GridHeaderModel(new HeaderStyles(null, null), 'vendor_lot', 'Vendor lot', false, false, null, false),       project: new GridHeaderModel(new HeaderStyles(null, null), 'project', 'Project', false, false, null, false),       net_weight: new GridHeaderModel(new HeaderStyles(null, null), 'net_weight', 'Net weight', false, false, null, false),       gross_weight: new GridHeaderModel(new HeaderStyles(null, null), 'gross_weight', 'Gross weight', false, false, null, false),       weight_uom: new GridHeaderModel(new HeaderStyles(null, null), 'weight_uom', 'Weight measure', false, false, null, false),       length: new GridHeaderModel(new HeaderStyles(null, null), 'length', 'Length', false, false, null, false),       width: new GridHeaderModel(new HeaderStyles(null, null), 'width', 'Width', false, false, null, false),       height: new GridHeaderModel(new HeaderStyles(null, null), 'height', 'Height', false, false, null, false),       dimension_uom: new GridHeaderModel(new HeaderStyles(null, null), 'dimension_uom', 'L x W x H measure', false, false, null, false),       net_volume: new GridHeaderModel(new HeaderStyles(null, null), 'net_volume', 'Net volume', false, false, null, false),       gross_volume: new GridHeaderModel(new HeaderStyles(null, null), 'gross_volume', 'Gross volume', false, false, null, false),       volume_uom: new GridHeaderModel(new HeaderStyles(null, null), 'volume_uom', 'Volume measure', false, false, null, false),       created_date: new GridHeaderModel(new HeaderStyles(null, null), 'created_date', 'Created on', false, false, null, false),       created_user: new GridHeaderModel(new HeaderStyles(null, null), 'created_user', 'Created by', false, false, null, false),       licenseplate_type: new GridHeaderModel(new HeaderStyles(null, null), 'licenseplate_type', 'LP type', false, false, null, false),       licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'licenseplate', 'LP', false, false, null, false),       location: new GridHeaderModel(new HeaderStyles(null, null), 'location', 'Location', false, false, null, false),       warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'warehouse', 'Warehouse', false, false, null, false),       outbound_shipment: new GridHeaderModel(new HeaderStyles(null, null), 'outbound_shipment', 'Outbound shipment', false, false, null, false),       outbound_shipment_status: new GridHeaderModel(new HeaderStyles(null, null), 'outbound_shipment_status', 'Outbound shipment status', false, false, null, false),       notes: new GridHeaderModel(new HeaderStyles(null, null), 'notes', 'Notes', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_child_serialnumbers_gridComponentRowModel[] = [];

  @Input('chainHead') set $inParams_chainHead(value: any) {
    this.inParams['chainHead'] = value;
  }
  get $inParams_chainHead(): any {
    return this.inParams['chainHead'] ;
  }
  @Input('archived') set $inParams_archived(value: any) {
    this.inParams['archived'] = value;
  }
  get $inParams_archived(): any {
    return this.inParams['archived'] ;
  }
  @Input('fullTextSearch') set $inParams_fullTextSearch(value: any) {
    this.inParams['fullTextSearch'] = value;
  }
  get $inParams_fullTextSearch(): any {
    return this.inParams['fullTextSearch'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_child_serialnumbers_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Child serials';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.chainHead)) {
        this.$missingRequiredInParams.push('chainHead');
      }
      if(isNil(this.inParams.archived)) {
        this.$missingRequiredInParams.push('archived');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 50;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      chainHead:  $grid.inParams.chainHead ,
      archived:  false ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    try {
      const data = await this.$datasources.SerialNumbers.ds_child_serialnumbers_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_child_serialnumbers_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_child_serialnumbers_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_grid_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_grid_data_loaded(event = null) {
    return this.on_grid_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_grid_data_loadedInternal(
    $grid: FootprintManager_child_serialnumbers_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_child_serialnumbers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  var serialNumberIds = $grid.rows.map(r => r.entity.Id)
  
  let serialPaths = (await $flows.SerialNumbers.get_serialnumber_parent_path({ serialnumberIds: serialNumberIds }));
  
  for (let row of $grid.rows) {
      if ($utils.isDefined(serialPaths.serialInfo)) {
          let serialId = serialPaths.serialInfo.find(x => x.serialId === row.entity.Id).serialPath
          if ($utils.isDefined(serialId)) {
              row.cells.parent_path.displayControl.text = serialId;
          }
      }
  }
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
